import { useContext } from "react";
import { Context } from "./Context";

export const useStore = (): any => {
  const store = useContext(Context);
  return store;
};
